function hasErrors(fieldsError) {
  return fieldsError
    ? Object.keys(fieldsError).some(field => fieldsError[field])
    : false;
}
const progresses = {};

progresses.default = [
  {
    title: "Исполнитель",
    name: "name",
    completed: false,
    fields: ["subjectKey", "lastname", "name", "nameLegal", "inn", "birthDate"],
    check: (values, form) => {
      switch (values.subjectKey) {
        case "legal":
        case "individ":
          return !!(
            !hasErrors(form.getFieldsError(["nameLegal", "inn"])) &&
            values.nameLegal &&
            values.inn
          );
        case "physical":
          return !!(
            !hasErrors(
              form.getFieldsError(["lastname", "name", "inn", "birthDate"])
            ) &&
            values.lastname &&
            values.name &&
            values.inn &&
            values.birthDate
          );
        default:
          return false;
      }
    },
    getDescription: values => {
      switch (values.subjectKey) {
        case "legal":
          return `ЮЛ, ${values.nameLegal}`;
        case "physical":
          return `ФЛ, ${values.lastname} ${values.name && values.name[0]}. `;
        case "individ":
          return `ИП, ${values.nameLegal}`;
        default:
          return null;
      }
    }
  },
  {
    title: "Контактная информация",
    name: "contacts",
    fields: ["phone", "phoneCode", "email"],
    completed: false,
    check: (values, form) => {
      return !!(
        !hasErrors(form.getFieldsError(["phone", "phoneCode", "email"])) &&
        values.phone &&
        values.phoneCode &&
        values.email
      );
    },
    getDescription: values => {
      return values.phoneCode + values.phone + ", " + values.email;
    }
  },
  // {
  //   title: "Реквизиты банка",
  //   name: "bankDetails",
  //   fields: [
  //     "bankName0",
  //     "bankAccountNum0",
  //     "bik0",
  //     "accountCorr0",
  //     "bankAccount"
  //   ],
  //   completed: false,
  //   check: (values, form) => {
  //     if (values.bankAccount && values.bankAccount.length) {
  //       return !!(
  //         !hasErrors(
  //           form.getFieldsError([
  //             "bankName0",
  //             "bankAccountNum0",
  //             "bik0",
  //             "accountCorr0"
  //           ])
  //         ) &&
  //         values.bankName0 &&
  //         values.bankAccountNum0 &&
  //         values.bik0 &&
  //         values.accountCorr0
  //       );
  //     } else {
  //       return false;
  //     }
  //   },
  //   getDescription: values => {
  //     return values.bankName0 && values.bankAccountNum0
  //       ? `${values.bankName0}, ${values.bankAccountNum0}`
  //       : "";
  //   }
  // }
];

export default progresses;
